import { apiClient } from "./ApiClient";

// Blend endpoints
export const retrieveAllBlendsApi = () =>
  apiClient.get('/api/blends');

export const retrieveBlendByIdApi = (id) =>
  apiClient.get(`/api/blends/${id}`);

export const createBlendApi = (blend) =>
  apiClient.post('/api/blends', blend);

export const updateBlendApi = (id, blend) =>
  apiClient.put(`/api/blends/${id}`, blend);

export const deleteBlendApi = (id) =>
  apiClient.delete(`/api/blends/${id}`);

// Blend Version endpoints
export const retrieveBlendVersionsApi = (blendId) =>
  apiClient.get(`/api/blends/${blendId}/versions`);

export const retrieveBlendVersionByIdApi = (blendId, versionId) =>
  apiClient.get(`/api/blends/${blendId}/versions/${versionId}`);

export const createBlendVersionApi = (blendId, version) =>
  apiClient.post(`/api/blends/${blendId}/versions`, version);

export const updateBlendVersionApi = (blendId, versionId, version) =>
  apiClient.put(`/api/blends/${blendId}/versions/${versionId}`, version);

export const deleteBlendVersionApi = (blendId, versionId) =>
  apiClient.delete(`/api/blends/${blendId}/versions/${versionId}`);

// Blend Items endpoints
export const retrieveVersionItemsApi = (blendId, versionId) =>
  apiClient.get(`/api/blends/${blendId}/versions/${versionId}/items`);

export const retrieveVersionItemByIdApi = (blendId, versionId, itemId) =>
  apiClient.get(`/api/blends/${blendId}/versions/${versionId}/items/${itemId}`);

export const createVersionItemApi = (blendId, versionId, item) =>
  apiClient.post(`/api/blends/${blendId}/versions/${versionId}/items`, item);

export const updateVersionItemApi = (blendId, versionId, itemId, item) =>
  apiClient.put(`/api/blends/${blendId}/versions/${versionId}/items/${itemId}`, item);

export const deleteVersionItemApi = (blendId, versionId, itemId) =>
  apiClient.delete(`/api/blends/${blendId}/versions/${versionId}/items/${itemId}`);